module.exports = __webpack_public_path__ + "img/더비시.38ac6319.png";